import { render } from "./VoipExpiring.vue?vue&type=template&id=11a2067e"
import script from "./VoipExpiring.vue?vue&type=script&lang=js"
export * from "./VoipExpiring.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "11a2067e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11a2067e', script)) {
    api.reload('11a2067e', script)
  }
  
  module.hot.accept("./VoipExpiring.vue?vue&type=template&id=11a2067e", () => {
    api.rerender('11a2067e', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipExpiring.vue"

export default script